// Origem do visitante (UTM e cliques de anúncio), guardada no navegador e enviada com leads, carrinhos e pedidos.
const KEY = 'pp_attr';
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'ttclid', 'msclkid'];

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; }
};
const write = (v) => {
  try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* armazenamento indisponível */ }
};

/** Chame uma vez ao abrir o site. Novos parâmetros de campanha substituem os antigos. */
export function captureAttribution() {
  try {
    const url = new URL(window.location.href);
    const found = {};
    PARAMS.forEach((k) => { const v = url.searchParams.get(k); if (v) found[k] = v.slice(0, 300); });
    const prev = read();
    const externalRef = document.referrer && new URL(document.referrer).host !== window.location.host ? document.referrer : '';

    if (Object.keys(found).length) {
      write({ ...found, referrer: externalRef || prev?.referrer, landing_page: url.pathname, first_seen: prev?.first_seen || new Date().toISOString() });
    } else if (!prev) {
      write({ referrer: externalRef || undefined, landing_page: url.pathname, first_seen: new Date().toISOString() });
    }
  } catch { /* ignora */ }
}

// Leva junto a escolha dos cookies (granted/denied), para o servidor respeitar na hora de avisar o Google Ads da venda.
export const getAttribution = () => {
  let consent;
  try { consent = localStorage.getItem('pp_consent') || undefined; } catch { /* ignora */ }
  const a = read();
  if (!a && !consent) return undefined;
  return { ...(a || {}), ...(consent ? { consent } : {}) };
};
